module.exports = __webpack_public_path__ + "media/images/benefit-01-61c235d454d5d06b682467354ca934e9.svg";